import { render } from "./LogoProVentas.vue?vue&type=template&id=3f6d624a&scoped=true"
import script from "./LogoProVentas.vue?vue&type=script&lang=js"
export * from "./LogoProVentas.vue?vue&type=script&lang=js"

import "./LogoProVentas.vue?vue&type=style&index=0&id=3f6d624a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6d624a"]])

export default __exports__